module.exports = __webpack_public_path__ + "img/panda.78fbd985.jpg";